var map = {
	"./Common/BaseLoader.vue": "pdpR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aWHI";


//////////////////
// WEBPACK FOOTER
// ./src/components Base[A-Z]\w+\.(vue|js)$
// module id = aWHI
// module chunks = 1